import {
  collection,
  addDoc,
  Timestamp,
  doc,
  getDocs,
} from "firebase/firestore";
import { db, handleGoogleSignInIfNeeded } from "./Firestore";

const COLLECTION_NAME = "PhotoBoothImages";

export const AddImage = async (imageData: any) => {
  try {
    await handleGoogleSignInIfNeeded();
    const docRef = await addDoc(collection(db, COLLECTION_NAME), {
      image: imageData,
      captureTimestamp: Timestamp.fromDate(new Date()),
    });
    console.log("Document written with ID: ", docRef.id);
  } catch (e) {
    console.error("Error adding document: ", e);
  }
};

export const GetImages = async () => {
  try {
    await handleGoogleSignInIfNeeded();
    const docRef: any = collection(db, COLLECTION_NAME);
    const snapshot = await getDocs(docRef);

    return snapshot.docs.map((doc: any) => doc.data().image);
  } catch (e) {
    console.error("Error getting document: ", e);
  }
};
